import http from "../../http-common";

class EducationPagesService {
    getEducationPages(path: string) {
        return http.get(`education?path=${path}`);
    }
}

export default new EducationPagesService();
